import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AUTHGWCONSTANTS } from '../authorization/authconstatnts';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  currentMessage = new BehaviorSubject(null);
  headers: any;

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private http: HttpClient
  ) {
    const xenAuth = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);
    this.headers = {
      'XEN-AUTHORIZATION': xenAuth
    };
    this.headers = { ...this.headers, ...environment.platformInfo };
  }

  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        if (token) {
          this.sendTokenToBackend(token);
        } else {
          console.warn('Token is null or undefined');
        }
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  sendTokenToBackend(token: string) {
    const url = `${environment.proxyApiUrl}/api/notification/device_token`;
    const headers = this.headers;
    this.http.post(url, { deviceToken: token }, { headers }).subscribe();
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload) => {
      this.currentMessage.next(payload);
    });
  }
}
